export default {
    name: 'PaymentChoice',
    props: {
        paymentChoice: {
            type: Array | Object,
            default: []
        }
    },
    data() {
        return {
            paymentMethodLocal: ''
        };
    },
    methods: {
        selectedMethod(payment) {
            this.paymentMethodLocal = payment.value;
            this.$emit('setPaymentMethod', payment.value);
        }
    }
};
